"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9951],{

/***/ 19951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xX": function() { return /* binding */ ItemNoticeProvider; },
  "p4": function() { return /* binding */ useItemNoticeContext; }
});

// UNUSED EXPORTS: ItemNoticeContext

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(72730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./domains/core/storefront/legacy/index.ts
var legacy = __webpack_require__(70014);
;// CONCATENATED MODULE: ./domains/draft/draft-graphql.ts
var GetDraftsCount = "\n  query getDraftsCount(\n    $filter: CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType\n    $paginate: PaginatorInputArgs\n    $sort: CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType\n  ) {\n    draftCollection(filter: $filter, paginate: $paginate, sort: $sort) {\n      items {\n        portfolioItem {\n          isCustomized\n        }\n      }\n      pagination {\n        page\n        perPage\n        total\n      }\n    }\n  }\n";
var draft_graphql_GetAllDrafts = "\n  query getAllDrafts(\n    $filter: CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType\n    $paginate: PaginatorInputArgs\n    $sort: CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType\n  ) {\n    draftCollection(filter: $filter, paginate: $paginate, sort: $sort) {\n      items {\n        id\n        draftGroupId\n        image\n        price\n        quantity\n        userId\n        updatedAt\n        portfolioItem {\n          id\n          memberId\n          notes\n          tenant\n          customizer {\n            stateId\n            urlPrint\n            urlProofs {\n              position\n              url\n            }\n            userId\n          }\n          isCustomized\n        }\n        variation {\n          id\n          catalogProduct {\n            externalId\n            catalogProductTypeCode\n            name\n            slug\n            catalogProductType {\n              name\n            }\n          }\n          catalogProductSuiteCode\n          images {\n            url\n            order\n            role\n          }\n          optionValues {\n            name\n            optionId\n            valueId\n          }\n          isSample\n        }\n        parentItemId\n      }\n      pagination {\n        page\n        perPage\n        total\n      }\n    }\n  }\n";

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./domains/draft/draft.schema.ts

var Pagination = lib.z.object({
    page: lib.z.number(),
    perPage: lib.z.number(),
    total: lib.z.number()
});
var urlProofs = lib.z.object({
    position: lib.z.number(),
    url: lib.z.string()
});
var Customizer = lib.z.object({
    stateId: lib.z.string(),
    urlPrint: lib.z.string(),
    urlProofs: lib.z.array(urlProofs),
    userId: lib.z.string()
});
var PortfolioItem = lib.z.object({
    id: lib.z.string(),
    memberId: lib.z.string().nullish(),
    notes: lib.z.string().nullish(),
    tenant: lib.z.string(),
    customizer: Customizer.nullish(),
    isCustomized: lib.z.boolean().nullish()
});
var CatalogProduct = lib.z.object({
    externalId: lib.z.string(),
    catalogProductTypeCode: lib.z.string(),
    name: lib.z.string(),
    slug: lib.z.string(),
    catalogProductType: lib.z.object({
        name: lib.z.string()
    })
});
var VariationImage = lib.z.object({
    url: lib.z.string(),
    order: lib.z.number(),
    role: lib.z.string()
});
var OptionValues = lib.z.object({
    name: lib.z.string(),
    optionId: lib.z.string(),
    valueId: lib.z.string()
});
var Variation = lib.z.object({
    id: lib.z.string(),
    catalogProduct: CatalogProduct,
    images: lib.z.array(VariationImage).nullish(),
    optionValues: lib.z.array(OptionValues),
    isSample: lib.z.boolean().nullish(),
    catalogProductSuiteCode: lib.z.string().nullish()
});
var Draft = lib.z.object({
    id: lib.z.string(),
    draftGroupId: lib.z.string(),
    image: lib.z.string(),
    updatedAt: lib.z.string().nullish(),
    portfolioItem: PortfolioItem,
    variation: Variation,
    price: lib.z.number(),
    quantity: lib.z.number(),
    userId: lib.z.string(),
    parentItemId: lib.z.string().nullish()
});
var PortfolioItemIsCustomized = PortfolioItem.pick({
    isCustomized: true
});
var DraftCustomized = lib.z.object({
    portfolioItem: PortfolioItemIsCustomized
});
var DraftsCount = lib.z.object({
    items: lib.z.array(DraftCustomized),
    pagination: Pagination
});
var draft_schema_DraftCollection = lib.z.object({
    items: lib.z.array(Draft),
    pagination: Pagination
});

// EXTERNAL MODULE: ./modules/core/services/honeybadger.service.ts
var honeybadger_service = __webpack_require__(69354);
;// CONCATENATED MODULE: ./domains/draft/draft.query.ts






function getDraftsCount(headers) {
    return _getDraftsCount.apply(this, arguments);
}
function _getDraftsCount() {
    _getDraftsCount = (0,src_async_to_generator/* default */.Z)(function(headers) {
        var variables, response, drafts, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    variables = {};
                    return [
                        4,
                        (0,legacy/* storefrontAPIFetch */.s3)(GetDraftsCount, variables, headers)
                    ];
                case 1:
                    response = _state.sent();
                    drafts = DraftsCount.safeParse(response.draftCollection);
                    if (!drafts.success) {
                        throw new Error("Invalid drafts count", drafts.error);
                    }
                    return [
                        2,
                        drafts.data
                    ];
                case 2:
                    error = _state.sent();
                    honeybadger_service["default"].notify(error, {
                        name: "getDraftsCount @ domains/draft/draft.query.ts",
                        message: error === null || error === void 0 ? void 0 : error.message
                    });
                    throw new Error("Error in draft.query.ts: ".concat(error));
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getDraftsCount.apply(this, arguments);
}
function getAllDrafts(variables, headers) {
    return _getAllDrafts.apply(this, arguments);
}
function _getAllDrafts() {
    _getAllDrafts = _async_to_generator(function(variables, headers) {
        var response, drafts, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        storefrontAPIFetch(GetAllDrafts, variables, headers)
                    ];
                case 1:
                    response = _state.sent();
                    drafts = DraftCollection.safeParse(response.draftCollection);
                    if (!drafts.success) {
                        throw new Error("Invalid drafts:", drafts.error);
                    }
                    return [
                        2,
                        drafts.data
                    ];
                case 2:
                    error = _state.sent();
                    Honeybadger.notify(error, {
                        name: "getAllDrafts @ domains/draft/draft.query.ts",
                        message: error === null || error === void 0 ? void 0 : error.message
                    });
                    throw new Error("Error in draft.query.ts: ".concat(error));
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getAllDrafts.apply(this, arguments);
}

// EXTERNAL MODULE: ./services/storefront/cart/cart.ts
var cart_cart = __webpack_require__(10624);
// EXTERNAL MODULE: ./services/storefront/drafts/drafts.ts + 2 modules
var drafts = __webpack_require__(55288);
// EXTERNAL MODULE: ./utils/helpers/index.ts
var helpers = __webpack_require__(96645);
// EXTERNAL MODULE: ./utils/pages/index.ts
var pages = __webpack_require__(59837);
;// CONCATENATED MODULE: ./modules/core/contexts/ItemNotice/ItemNoticeReducer.tsx









var defaultCounters = {
    cart: 0,
    drafts: 0
};
function refetchItemCountersReducer(currentItemCounters, action) {
    switch(action.type){
        case "cart":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentItemCounters), {
                    cart: action.response.cart
                });
            }
        case "drafts":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentItemCounters), {
                    drafts: action.response.drafts
                });
            }
        case "all":
            {
                return (0,_object_spread/* default */.Z)({}, currentItemCounters, action.response);
            }
        case "initialProps":
            {
                return action.response || defaultCounters;
            }
    }
}
function getItemCount(itemCounterType) {
    return _getItemCount.apply(this, arguments);
}
function _getItemCount() {
    _getItemCount = (0,src_async_to_generator/* default */.Z)(function(itemCounterType) {
        var headers, response, response1, isLoggedIn, cart, responseDraft;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    headers = (0,helpers/* getClientHeaders */.h3)();
                    switch(itemCounterType){
                        case "cart":
                            return [
                                3,
                                1
                            ];
                        case "drafts":
                            return [
                                3,
                                3
                            ];
                        case "all":
                            return [
                                3,
                                5
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 1:
                    return [
                        4,
                        (0,cart_cart/* getCartItemCount */.zt)(headers)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultCounters), {
                            cart: response
                        })
                    ];
                case 3:
                    return [
                        4,
                        getDraftsCount(headers)
                    ];
                case 4:
                    response1 = _state.sent();
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultCounters), {
                            drafts: response1.pagination.total
                        })
                    ];
                case 5:
                    isLoggedIn = !!(0,pages.parseXOMembershipToken)(document.cookie);
                    return [
                        4,
                        (0,drafts/* getCartDraftsCounters */.TB)(isLoggedIn, headers)
                    ];
                case 6:
                    cart = _state.sent().cart;
                    return [
                        4,
                        getDraftsCount(headers)
                    ];
                case 7:
                    responseDraft = _state.sent();
                    return [
                        2,
                        {
                            cart: cart,
                            drafts: responseDraft.pagination.total
                        }
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return _getItemCount.apply(this, arguments);
}

;// CONCATENATED MODULE: ./modules/core/contexts/ItemNotice/index.tsx







var itemNoticeInitialState = {
    displayNotificationMessage: false,
    content: null,
    shouldAutoClose: true
};
var ItemNoticeContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var ItemNoticeProvider = function(param) {
    var children = param.children, itemCounters = param.itemCounters;
    var ref = (0,react.useReducer)(refetchItemCountersReducer, itemCounters), itemCountersState = ref[0], dispatch = ref[1];
    var ref1 = (0,react.useState)(itemNoticeInitialState), itemNoticeState = ref1[0], setItemNoticeState = ref1[1];
    (0,react.useEffect)(function() {
        dispatch({
            type: "initialProps",
            response: itemCounters
        });
    }, [
        itemCounters
    ]);
    function refetchItemCounters(itemCounterType) {
        return _refetchItemCounters.apply(this, arguments);
    }
    function _refetchItemCounters() {
        _refetchItemCounters = (0,src_async_to_generator/* default */.Z)(function(itemCounterType) {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getItemCount(itemCounterType)
                        ];
                    case 1:
                        response = _state.sent();
                        dispatch({
                            type: itemCounterType,
                            response: response
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _refetchItemCounters.apply(this, arguments);
    }
    var displayNotificationMessage = itemNoticeState.displayNotificationMessage, shouldAutoClose = itemNoticeState.shouldAutoClose;
    (0,react.useEffect)(function() {
        if (displayNotificationMessage && shouldAutoClose) {
            var notificationTimeout = 4000;
            var notificationTimer = setTimeout(function() {
                return setItemNoticeState(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        displayNotificationMessage: false
                    });
                });
            }, notificationTimeout);
            return function() {
                return clearTimeout(notificationTimer);
            };
        }
    }, [
        displayNotificationMessage,
        setItemNoticeState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemNoticeContext.Provider, {
        value: {
            itemNoticeState: itemNoticeState,
            setItemNoticeState: setItemNoticeState,
            itemCountersState: itemCountersState,
            refetchItemCounters: refetchItemCounters
        },
        children: children
    });
};
var useItemNoticeContext = function() {
    var context = (0,react.useContext)(ItemNoticeContext);
    if (context === undefined) {
        throw new Error("useItemNoticeContext must be used within a ItemNoticeProvider");
    }
    return context;
};


/***/ }),

/***/ 10624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ reportItemIneligibleForReorderError; },
/* harmony export */   "RS": function() { return /* binding */ addReorderedSampleItemToCart; },
/* harmony export */   "Zs": function() { return /* binding */ addOrderedItemToCart; },
/* harmony export */   "Zx": function() { return /* binding */ addPersonalizedSampleToCart; },
/* harmony export */   "zt": function() { return /* binding */ getCartItemCount; }
/* harmony export */ });
/* unused harmony export ReorderReasonCode */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72730);
/* harmony import */ var _domains_core_storefront_legacy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70014);
/* harmony import */ var _graphql_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50828);
/* harmony import */ var _graphql_commerceCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78621);
/* harmony import */ var _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5417);
/* harmony import */ var _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0__);






function addToCart(input) {
    return (0,_domains_core_storefront_legacy__WEBPACK_IMPORTED_MODULE_1__/* .storefrontAPIFetch */ .s3)(_graphql_commerceCart__WEBPACK_IMPORTED_MODULE_2__/* .AddItemToCart */ .xL, {
        input: input
    });
}
var ReorderReasonCode;
(function(ReorderReasonCode) {
    ReorderReasonCode[ReorderReasonCode["BuyMore"] = 4] = "BuyMore";
})(ReorderReasonCode || (ReorderReasonCode = {}));
function addPersonalizedSampleToCart(sampleVariationId) {
    return _addPersonalizedSampleToCart.apply(this, arguments);
}
function _addPersonalizedSampleToCart() {
    _addPersonalizedSampleToCart = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(sampleVariationId) {
        var ref, ref1, cart;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        addToCart({
                            isCustomized: true,
                            quantity: 1,
                            variationId: sampleVariationId
                        })
                    ];
                case 1:
                    cart = _state.sent().cart;
                    return [
                        2,
                        {
                            cartId: cart.addItem.cart.storeCartId,
                            portfolioItemId: (ref = cart.addItem.item) === null || ref === void 0 ? void 0 : (ref1 = ref.portfolioItem) === null || ref1 === void 0 ? void 0 : ref1.id
                        }
                    ];
            }
        });
    });
    return _addPersonalizedSampleToCart.apply(this, arguments);
}
var reportItemIneligibleForReorderError = function(originalOrderId, item) {
    var ref;
    _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default().notify("Attempted reorder of ineligible order item", {
        context: {
            orderId: originalOrderId,
            orderItemId: item.id,
            portfolioItemId: (ref = item.portfolioItem) === null || ref === void 0 ? void 0 : ref.id,
            variationId: item.variation.id,
            reorderVariationId: item.reorderVariationId,
            reorderEligible: item.reorderEligible
        }
    });
};
function addOrderedItemToCart(originalOrderId, item) {
    return _addOrderedItemToCart.apply(this, arguments);
}
function _addOrderedItemToCart() {
    _addOrderedItemToCart = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(originalOrderId, item) {
        var variables, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, response, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!item.reorderEligible || !item.reorderVariationId) {
                        reportItemIneligibleForReorderError(originalOrderId, item);
                        throw new Error("Item is not eligible for reorder");
                    }
                    variables = {
                        input: {
                            quantity: item.variation.productCode === "GBK" ? 1 : 15,
                            variationId: item.reorderVariationId,
                            isCustomized: Boolean(item.portfolioItem),
                            reorderAttributes: {
                                originalLineItemId: item.id.toString(),
                                originalOrderId: originalOrderId,
                                reorderReasonCode: ReorderReasonCode.BuyMore
                            }
                        }
                    };
                    if (item.portfolioItem) {
                        ;
                        variables.input.portfolioItem = {
                            customizer: (ref = item.portfolioItem) === null || ref === void 0 ? void 0 : ref.customizer,
                            memberId: (ref1 = item.portfolioItem) === null || ref1 === void 0 ? void 0 : ref1.memberId,
                            fileType: (ref2 = item.portfolioItem) === null || ref2 === void 0 ? void 0 : ref2.fileType,
                            selectableOptionValues: (ref3 = item.portfolioItem) === null || ref3 === void 0 ? void 0 : ref3.selectableOptionValues,
                            templateId: (ref4 = item.portfolioItem) === null || ref4 === void 0 ? void 0 : ref4.templateId
                        };
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_domains_core_storefront_legacy__WEBPACK_IMPORTED_MODULE_1__/* .storefrontAPIFetch */ .s3)(_graphql_cart__WEBPACK_IMPORTED_MODULE_5__/* .AddOrderedItemToCart */ .ee, variables)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        {
                            item: (ref5 = response.cart) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.addItem) === null || ref6 === void 0 ? void 0 : ref6.item,
                            cart: (ref7 = response.cart) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.addItem) === null || ref8 === void 0 ? void 0 : ref8.cart
                        }
                    ];
                case 3:
                    error = _state.sent();
                    _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default().notify("Adding ordered item to cart failed", {
                        message: error.message,
                        context: {
                            originalOrderId: originalOrderId,
                            originalOrderItemId: item.id,
                            mutationInput: variables.input
                        }
                    });
                    throw error;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _addOrderedItemToCart.apply(this, arguments);
}
function addReorderedSampleItemToCart(originalOrderId, item) {
    return _addReorderedSampleItemToCart.apply(this, arguments);
}
function _addReorderedSampleItemToCart() {
    _addReorderedSampleItemToCart = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(originalOrderId, item) {
        var variables, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, response, portfolioItemId, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!item.reorderEligible || !item.reorderVariationId) {
                        reportItemIneligibleForReorderError(originalOrderId, item);
                        throw new Error("Item is not eligible for reorder");
                    }
                    variables = {
                        input: {
                            quantity: 100,
                            variationId: item.reorderVariationId,
                            isCustomized: true
                        }
                    };
                    if (item.portfolioItem) {
                        ;
                        variables.input.portfolioItem = {
                            memberId: (ref = item.portfolioItem) === null || ref === void 0 ? void 0 : ref.memberId,
                            customizer: (ref1 = item.portfolioItem) === null || ref1 === void 0 ? void 0 : ref1.customizer,
                            fileType: (ref2 = item.portfolioItem) === null || ref2 === void 0 ? void 0 : ref2.fileType,
                            selectableOptionValues: (ref3 = item.portfolioItem) === null || ref3 === void 0 ? void 0 : ref3.selectableOptionValues,
                            templateId: (ref4 = item.portfolioItem) === null || ref4 === void 0 ? void 0 : ref4.templateId
                        };
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_domains_core_storefront_legacy__WEBPACK_IMPORTED_MODULE_1__/* .storefrontAPIFetch */ .s3)(_graphql_cart__WEBPACK_IMPORTED_MODULE_5__/* .AddOrderedSampleItemToCart */ .Xr, variables)
                    ];
                case 2:
                    response = _state.sent();
                    portfolioItemId = (ref5 = response.cart.addItem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.item) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.portfolioItem) === null || ref7 === void 0 ? void 0 : ref7.id;
                    if (!portfolioItemId) {
                        throw new Error("Ordered sample item added to cart without a portfolio item");
                    }
                    return [
                        2,
                        portfolioItemId
                    ];
                case 3:
                    error = _state.sent();
                    _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default().notify("Adding ordered sample item to cart failed", {
                        message: error.message,
                        context: {
                            originalOrderId: originalOrderId,
                            originalOrderItemId: item.id,
                            mutationInput: variables.input
                        }
                    });
                    throw error;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _addReorderedSampleItemToCart.apply(this, arguments);
}
function getCartItemCount(headers) {
    return _getCartItemCount.apply(this, arguments);
}
function _getCartItemCount() {
    _getCartItemCount = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(headers) {
        var ref, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_domains_core_storefront_legacy__WEBPACK_IMPORTED_MODULE_1__/* .storefrontAPIFetch */ .s3)(_graphql_commerceCart__WEBPACK_IMPORTED_MODULE_2__/* .CartItemCount */ .kI, undefined, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        (response === null || response === void 0 ? void 0 : (ref = response.cart) === null || ref === void 0 ? void 0 : ref.itemCount) || 0
                    ];
            }
        });
    });
    return _getCartItemCount.apply(this, arguments);
}


/***/ })

}]);